import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']
  static values = { successMessage: String }

  async submit() {
    const form = this.formTarget
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })

    if (response.ok) {
      form.reset()
      this.dispatch('success', {
        detail: { message: this.successMessageValue },
        prefix: 'feedback'
      })
    }
  }
}
